import { Injectable } from '@angular/core';
import {
  ApiQuery,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import { mapToModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  BankTransactionDirection,
  IBankTransaction,
} from '@kinet-open-network/shared/data-access/model';
import {
  ICheckAutoPairByIbanRequest,
  ICheckAutoPairByIbanResponse,
} from '../models/api/check-auto-pair-by-iban.model';
import { IPairTransactionData } from '../models/api/pair-transaction.model';
import { BankTransaction } from '../models/bank-transaction.model';

@Injectable({
  providedIn: 'root',
})
export class BankTransactionsService extends BaseApiService<BankTransaction> {
  override model = BankTransaction;

  override get endpoint(): string {
    return '/invoicing/banks/transactions';
  }

  protected override apiQueryToHttpParams(query?: ApiQuery | null) {
    if (query?.search) {
      const isIbanLike = /^([A-Z]{2}[0-9]{2})([ ]?[0-9]{1,4}){0,7}$/.test(
        query.search,
      );

      if (isIbanLike) {
        query = {
          ...query,
          search: query.search.replace(/\s+/g, ''),
        };
      }
    }

    return super.apiQueryToHttpParams(query);
  }

  autoPairTransaction(transactionId: string) {
    return this.http
      .post<IBankTransaction>(`${this.endpoint}/auto-pair`, {
        transactionId,
      })
      .pipe(mapToModel(BankTransaction));
  }

  pairTransaction(transactionId: string, data: IPairTransactionData) {
    return this.http
      .post<IBankTransaction>(`${this.endpoint}/pair`, {
        transactionId,
        ...data,
      })
      .pipe(mapToModel(BankTransaction));
  }

  removeAutoPairForIban(iban: string) {
    return this.http.delete<{ message: string }>(`${this.endpoint}/auto-pair`, {
      body: {
        iban,
      },
    });
  }

  checkAutoPairByIban(data: ICheckAutoPairByIbanRequest) {
    const payload: ICheckAutoPairByIbanRequest = {
      iban: data.iban,
    };

    if (data.transactionDirection) {
      payload.transactionDirection =
        data.transactionDirection as BankTransactionDirection;
    }

    return this.http.post<ICheckAutoPairByIbanResponse>(
      `${this.endpoint}/auto-pair/check`,
      payload,
    );
  }
}
